export const staticSuffix = 'cart'; // eslint-disable-line
export const micrositeName = 'yoda-microsite-cart';
export const esiHeaderRequiredRoutes = [];

export const isContextHeadersRequired = true;

export const app = {
    logTag: 'MICROSITE:CART',
};

export const configServerSettingsFlag = true;
